import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@services/session';

export const AuthGuard: CanActivateFn = () => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  if (sessionService.isAuthenticated()) {
    return true; //* Usuario autenticado, puede navegar.
  }

  router.navigate(['auth', 'login']); //* Redirigir a la página de autenticación.
  document.documentElement.scrollTop = 0;
  return false; //* Bloquear navegación.
};
